import React from "react";
import { Link } from "react-router-dom";

export const Materials = (props) => (
  <div id="materials">
    <div className="container">
      <div className="col-md-10 col-md-offset-1 section-title text-center">
        <h2>Our Marble</h2>
        <p>
          Six stones we quarry and finish ourselves. Names and full technical
          datasheets — density, absorption, flexural strength and finish samples —
          are sent on request.
        </p>
      </div>
      <div className="card-grid material-grid">
        {props.data
          ? props.data.map((d, i) => (
              <div key={`${d.name}-${i}`} className="material-card">
                  <div className="material-img">
                    <img src={d.image} alt={`${d.name} Omani marble`} className="img-responsive" />
                  </div>
                  <div className="material-body">
                    <h3>{d.name}</h3>
                    <span className="material-meta">{d.meta}</span>
                    <p>{d.text}</p>
                  </div>
              </div>
            ))
          : null}
      </div>
      <div className="text-center section-footer">
        <Link to="/contact" className="btn btn-custom">
          Request Samples
        </Link>
      </div>
    </div>
  </div>
);
